/**
 * Optional global defaults for export behavior.
 * Keep this lightweight; table-level behavior should be passed per request.
 */
export interface IExportProviderOptions {
  locale: string;
  dateFormat: string;
  csvDelimiter: string;
  csvBom: boolean;
}

/**
 * Default provider options used when caller does not override values.
 */
export const EXPORT_PROVIDER_DEFAULT_OPTIONS: IExportProviderOptions = {
  locale: 'en',
  dateFormat: 'yyyy-MM-dd',
  csvDelimiter: ',',
  csvBom: true,
};
